// (() => {
//   'use strict';
//   if (customElements.get('product-orientation')) return;

//   class ProductOrientation extends HTMLElement {
//     connectedCallback() {
//       if (this.controller) return;
//       this.owner = this.closest('[data-section-type="product"]');
//       if (!this.owner) return;
//       this.controller = new AbortController();
//       this.native = this.dataset.defaultOrientation || 'Portrait';
//       this.choice = this.choice || (this.native === 'Landscape' ? 'Landscape' : 'Portrait');
//       this.picker = this.closest('variant-radios, variant-selects');
//       this.variantSizes = new Map();
//       try {
//         const variants = JSON.parse(this.picker?.querySelector('script[type="application/json"]')?.textContent || '[]');
//         variants.forEach(variant => this.variantSizes.set(String(variant.id), variant.options?.[Number(this.dataset.sizeOptionIndex)]));
//       } catch (_) { /* The selected size control remains the fallback. */ }
//       this.addEventListener('click', event => {
//         const card = event.target.closest('[data-orientation-value]');
//         if (card && this.contains(card)) this.select(card.dataset.orientationValue);
//       }, { signal: this.controller.signal });
//       this.owner.addEventListener('change', event => this.refresh(event.target), { signal: this.controller.signal });
//       // Capture runs before the product form serializes its cart request.
//       this.owner.addEventListener('submit', event => this.refresh(event.target), {
//         capture: true, signal: this.controller.signal
//       });
//       // Variant/theme-editor rendering may replace either owning form.
//       this.observer = new MutationObserver(() => this.refresh());
//       this.observer.observe(this.owner, { childList: true, subtree: true });
//       this.refresh();
//     }

//     disconnectedCallback() {
//       this.observer?.disconnect();
//       this.controller?.abort();
//       this.controller = null;
//     }

//     forms() {
//       const ids = [this.dataset.formId, this.dataset.stickyFormId];
//       // input[name=id] shadows form.id through named form access.
//       return Array.from(this.owner.querySelectorAll('form')).filter(form => ids.includes(form.getAttribute('id')));
//     }

//     size(source) {
//       const forms = this.forms();
//       const sourceForm = source?.closest('form');
//       const fromOwnedForm = forms.includes(sourceForm);
//       const stickySelect = source?.getAttribute('id') === this.dataset.stickyVariantId;
//       const variantId = stickySelect ? source.value :
//         (fromOwnedForm ? sourceForm : forms[0])?.querySelector('[name="id"]')?.value;
//       return this.variantSizes.get(String(variantId)) ||
//         this.picker?.querySelector('fieldset[data-option-handle="size"] input:checked')?.value ||
//         this.dataset.selectedSize || '';
//     }

//     select(value) {
//       if (value !== 'Portrait' && value !== 'Landscape') return;
//       if (this.squareCanvas || (this.dataset.nativeOnly === 'true' && value !== this.native)) return;
//       this.choice = value;
//       this.refresh();
//     }

//     text(selector, value) {
//       const node = this.querySelector(selector);
//       // Avoid generating a new child-list mutation when nothing changed.
//       if (node && node.textContent !== value) node.textContent = value;
//     }

//     refresh(source) {
//       const dimensions = this.size(source).match(/^\s*(\d+(?:\.\d+)?)\s*(?:cm|in(?:ches)?|["″])?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
//       this.squareCanvas = !!dimensions && Number(dimensions[1]) > 0 && Number(dimensions[1]) === Number(dimensions[2]);
//       const nativeOnly = this.dataset.nativeOnly === 'true';
//       const squareArt = nativeOnly && this.native === 'Square' && !this.squareCanvas;
//       this.value = this.squareCanvas ? 'Square' : squareArt ? null : nativeOnly ? this.native : this.choice;
//       this.text('[data-orientation-label]', squareArt ? 'Artwork orientation:' : 'Orientation:');
//       this.text('[data-orientation-header]', squareArt ? 'Square' : this.value);
//       this.text('[data-orientation-fixed-title]', this.squareCanvas ? 'Square canvas' : 'Square artwork');
//       this.text('[data-orientation-fixed-description]', this.squareCanvas ? 'Equal width and height' : 'The original artwork is square.');
//       const fixed = this.querySelector('[data-orientation-fixed]');
//       const grid = this.querySelector('[data-orientation-grid]');
//       if (fixed) fixed.hidden = !this.squareCanvas && !squareArt;
//       if (grid) grid.hidden = this.squareCanvas || squareArt;
//       const note = this.querySelector('[data-orientation-native-note]');
//       if (note) note.hidden = this.squareCanvas || squareArt;
//       this.querySelectorAll('[data-orientation-value]').forEach(card => {
//         const selected = card.dataset.orientationValue === this.value;
//         card.classList.toggle('is-selected', selected);
//         card.setAttribute('aria-pressed', String(selected));
//         card.disabled = this.squareCanvas || (nativeOnly && card.dataset.orientationValue !== this.native);
//       });
//       this.syncForms();
//     }

//     syncForms() {
//       this.forms().forEach(form => {
//         let input = form.querySelector('input[name="properties[Orientation]"]');
//         if (!this.value) {
//           input?.remove();
//           return;
//         }
//         if (!input) {
//           input = document.createElement('input');
//           input.type = 'hidden';
//           input.name = 'properties[Orientation]';
//           form.appendChild(input);
//         }
//         input.value = this.value;
//       });
//     }
//   }

//   customElements.define('product-orientation', ProductOrientation);
// })();
(() => {
  'use strict';
  if (customElements.get('product-orientation')) return;

  // Uploadcare rotates counterclockwise; use 270 if the printer wants clockwise.
  const LANDSCAPE_ROTATE = 90;
  // 'center' or 'face' (face-aware crop, test before going live).
  const CROP_MODE = 'center';
  const gcd = (a, b) => (b ? gcd(b, a % b) : a);

  // The orientation picker currently on the page (used by the popup filter below).
  let activePicker = null;

  // Turn every ratio in UploadKit's crop list into the chosen orientation, keeping order.
  // "4:5, 3:4, 1:1" -> Portrait: "4:5, 3:4, 1:1" | Landscape: "5:4, 4:3, 1:1".
  // Works with your existing portrait-only lists; duplicates are removed.
  function filterCrop(crop, orientation) {
    if (typeof crop !== 'string' || (orientation !== 'Portrait' && orientation !== 'Landscape')) return crop;
    const out = [];
    crop.split(',').map(s => s.trim()).filter(Boolean).forEach(r => {
      const m = r.match(/^(\d+(?:\.\d+)?)\s*[:x]\s*(\d+(?:\.\d+)?)$/);
      let next = r; // leave "free" or unknown values alone
      if (m) {
        const a = m[1], b = m[2];
        const portrait = Number(a) <= Number(b);
        next = orientation === 'Portrait' ? (portrait ? `${a}:${b}` : `${b}:${a}`)
                                          : (portrait ? `${b}:${a}` : `${a}:${b}`);
      }
      if (!out.includes(next)) out.push(next);
    });
    return out.length ? out.join(', ') : crop;
  }

  // UploadKit opens Uploadcare's popup via uploadcare.openDialog(files, settings),
  // passing your per-size crop list from its dashboard. Filter that list by orientation.
  function patchDialog() {
    const uc = window.uploadcare;
    if (!uc || typeof uc.openDialog !== 'function' || uc.openDialog.__pml) return;
    const original = uc.openDialog;
    const wrapped = function (...args) {
      const settings = args.find((a, i) => i > 0 && a && typeof a === 'object');
      if (settings && activePicker && !activePicker.squareCanvas) {
        settings.crop = filterCrop(settings.crop, activePicker.value);
      }
      return original.apply(this, args);
    };
    wrapped.__pml = true;
    uc.openDialog = wrapped;
  }


  // Split an Uploadcare URL into its base (with file UUID) and its edit operations.
  function parseUrl(src) {
    const m = (src || '').match(/^(https:\/\/[^/]+\/[0-9a-f-]{36}\/)(.*)$/i);
    if (!m) return null;
    return { base: m[1], ops: m[2].split('-/').filter(Boolean).map(op => op.replace(/\/?$/, '/')) };
  }

  // Rebuild the URL with the customer's edits, minus thumbnail sizing and
  // UploadKit's automatic first crop, then fit it to the canvas ratio.
  function cropUrl(photo, autoCrops, ratio) {
    const ops = photo.ops
      .filter(op => !/^(resize|scale_crop|preview)\//.test(op) && !autoCrops.includes(op))
      .map(op => '-/' + op)
      .join('');
    const crop = CROP_MODE === 'face' ? `-/crop/face/${ratio}/` : `-/crop/${ratio}/center/`;
    return photo.base + ops + crop;
  }

  class ProductOrientation extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.owner = this.closest('[data-section-type="product"]');
      if (!this.owner) return;
      this.controller = new AbortController();
      activePicker = this;
      this.native = this.dataset.defaultOrientation || 'Portrait';
      this.choice = this.choice || (this.native === 'Landscape' ? 'Landscape' : 'Portrait');
      this.picker = this.closest('variant-radios, variant-selects');
      this.variantSizes = new Map();
      try {
        const variants = JSON.parse(this.picker?.querySelector('script[type="application/json"]')?.textContent || '[]');
        variants.forEach(variant => this.variantSizes.set(String(variant.id), variant.options?.[Number(this.dataset.sizeOptionIndex)]));
      } catch (_) { /* The selected size control remains the fallback. */ }
      this.addEventListener('click', event => {
        const card = event.target.closest('[data-orientation-value]');
        if (card && this.contains(card)) this.select(card.dataset.orientationValue);
      }, { signal: this.controller.signal });
      this.owner.addEventListener('change', event => this.refresh(event.target), { signal: this.controller.signal });
      // Capture runs before the product form serializes its cart request.
      this.owner.addEventListener('submit', event => this.refresh(event.target), {
        capture: true, signal: this.controller.signal
      });
      // Variant/theme-editor rendering may replace either owning form,
      // and UploadKit may insert/replace its thumbnail anywhere on the page.
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['src']
      });
      this.refresh();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }

    forms() {
      const ids = [this.dataset.formId, this.dataset.stickyFormId];
      // input[name=id] shadows form.id through named form access.
      return Array.from(this.owner.querySelectorAll('form')).filter(form => ids.includes(form.getAttribute('id')));
    }

    size(source) {
      const forms = this.forms();
      const sourceForm = source?.closest?.('form');
      const fromOwnedForm = forms.includes(sourceForm);
      const stickySelect = source?.getAttribute?.('id') === this.dataset.stickyVariantId;
      const variantId = stickySelect ? source.value :
        (fromOwnedForm ? sourceForm : forms[0])?.querySelector('[name="id"]')?.value;
      return this.variantSizes.get(String(variantId)) ||
        this.picker?.querySelector('fieldset[data-option-handle="size"] input:checked')?.value ||
        this.dataset.selectedSize || '';
    }

    select(value) {
      if (value !== 'Portrait' && value !== 'Landscape') return;
      if (this.squareCanvas || (this.dataset.nativeOnly === 'true' && value !== this.native)) return;
      this.choice = value;
      this.refresh();
    }

    text(selector, value) {
      const node = this.querySelector(selector);
      // Avoid generating a new child-list mutation when nothing changed.
      if (node && node.textContent !== value) node.textContent = value;
    }

    refresh(source) {
      const dimensions = this.size(source).match(/^\s*(\d+(?:\.\d+)?)\s*(?:cm|in(?:ches)?|["″])?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      this.dims = dimensions ? [Number(dimensions[1]), Number(dimensions[2])] : null;
      this.squareCanvas = !!dimensions && Number(dimensions[1]) > 0 && Number(dimensions[1]) === Number(dimensions[2]);
      const nativeOnly = this.dataset.nativeOnly === 'true';
      const squareArt = nativeOnly && this.native === 'Square' && !this.squareCanvas;
      this.value = this.squareCanvas ? 'Square' : squareArt ? null : nativeOnly ? this.native : this.choice;
      this.text('[data-orientation-label]', squareArt ? 'Artwork orientation:' : 'Orientation:');
      this.text('[data-orientation-header]', squareArt ? 'Square' : this.value);
      this.text('[data-orientation-fixed-title]', this.squareCanvas ? 'Square canvas' : 'Square artwork');
      this.text('[data-orientation-fixed-description]', this.squareCanvas ? 'Equal width and height' : 'The original artwork is square.');
      const fixed = this.querySelector('[data-orientation-fixed]');
      const grid = this.querySelector('[data-orientation-grid]');
      if (fixed) fixed.hidden = !this.squareCanvas && !squareArt;
      if (grid) grid.hidden = this.squareCanvas || squareArt;
      const note = this.querySelector('[data-orientation-native-note]');
      if (note) note.hidden = this.squareCanvas || squareArt;
      this.querySelectorAll('[data-orientation-value]').forEach(card => {
        const selected = card.dataset.orientationValue === this.value;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-pressed', String(selected));
        card.disabled = this.squareCanvas || (nativeOnly && card.dataset.orientationValue !== this.native);
      });
      patchDialog();
      this.printPhoto = this.syncPhoto();
      this.syncForms();
    }

    // Canvas ratio for the current size + orientation, e.g. 40x50 Landscape -> "5:4".
    ratio() {
      if (!this.dims || !(this.dims[0] > 0 && this.dims[1] > 0)) return null;
      const [a, b] = this.dims.map(n => Math.round(n));
      const g = gcd(a, b);
      const short = Math.min(a, b) / g;
      const long = Math.max(a, b) / g;
      if (short === long) return '1:1';
      return this.value === 'Landscape' ? `${long}:${short}` : `${short}:${long}`;
    }

    // Crops the UploadKit preview live; returns the print-file URL (rotated for Landscape).
    syncPhoto() {
      const thumb = document.querySelector('img.uploadkit-thumbnail');
      if (!thumb) return null;
      const src = thumb.getAttribute('src');
      // Anything other than our own preview came from UploadKit:
      // either a new photo or the customer re-editing the same one.
      if (src !== this.previewSrc) {
        const parsed = parseUrl(src);
        if (!parsed) return null;
        const samePhoto = this.photo && this.photo.base === parsed.base;
        // First time we see a photo, its crop is UploadKit's automatic one: ignore it.
        // Crops the customer makes later (popup reopened) are kept.
        if (!samePhoto) this.autoCrops = parsed.ops.filter(op => op.startsWith('crop/'));
        this.photo = parsed;
      }
      if (!this.photo) return null;
      const ratio = this.ratio();
      const cropped = ratio && cropUrl(this.photo, this.autoCrops || [], ratio);
      if (!cropped) return null;
      // Landscape: the print file is rotated 90deg to fit the canvas.
      // The preview shows the un-rotated wide crop = how it looks hanging landscape.
      const printFile = this.value === 'Landscape' ? `${cropped}-/rotate/${LANDSCAPE_ROTATE}/` : cropped;
      const preview = cropped + '-/resize/300x/';
      this.previewSrc = preview;
      if (src !== preview) thumb.setAttribute('src', preview);
      if (thumb.hasAttribute('width')) thumb.removeAttribute('width');   // let the cropped shape show
      if (thumb.hasAttribute('height')) thumb.removeAttribute('height');
      return printFile;
    }

    setHidden(form, name, value) {
      let input = form.querySelector(`input[name="${name}"]`);
      if (!value) {
        input?.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      if (input.value !== value) input.value = value;
    }

    syncForms() {
      this.forms().forEach(form => {
        this.setHidden(form, 'properties[Orientation]', this.value);
        this.syncUploadKit(form);
      });
    }

    // Rewrite UploadKit's own properties ("Upload Photo" and its direct link) so the
    // edits in their URLs are our crop (+ rotate for Landscape). Order shows the print file.
    syncUploadKit(form) {
      if (!this.printPhoto || !this.photo) return;
      const uuid = (this.photo.base.match(/[0-9a-f-]{36}/i) || [])[0];
      if (!uuid) return;
      const mods = this.printPhoto.slice(this.photo.base.length); // e.g. -/crop/5:4/center/-/rotate/90/
      form.querySelectorAll('input[name^="properties["]').forEach(input => {
        const value = input.value;
        if (!value || !value.includes(uuid)) return;
        let next = value;
        if (/[?&]mo=/.test(value)) {
          // https://cdn.shopify.com-uploadkit.app/...download.html?...&uu=UUID&mo=-/crop/.../-/preview/&...
          const keepPreview = /[?&]mo=[^&]*-\/preview\//.test(value) ? '-/preview/' : '';
          next = value.replace(/([?&]mo=)[^&]*/, `$1${mods}${keepPreview}`);
        } else if (value.includes(`/${uuid}/`)) {
          // https://files.getuploadkit.com/ID/UUID/-/crop/.../-/preview/IMG.jpeg?image
          const start = value.indexOf(`/${uuid}/`) + uuid.length + 2;
          const rest = value.slice(start);
          const fileName = rest.slice(rest.lastIndexOf('/') + 1);
          const keepPreview = rest.includes('-/preview/') ? '-/preview/' : '';
          next = value.slice(0, start) + mods + keepPreview + fileName;
        }
        if (next !== value) input.value = next;
      });
    }
  }

  customElements.define('product-orientation', ProductOrientation);
})();